import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { useParams, useSearchParams } from "react-router-dom";
import Loader from "../../components/Loader";
import {
  getFreeGuideBasicDetailsApi,
  getGuideBasicDetailsApi,
  getModuleAccessInfoApi,
} from "../../api/candidate";
// import WebUtils from "../../../utils/WebUtils";
import WebUtils from "../../utils/WebUtils";
import { ROLES } from "../../constants/UserRoles";
import Utils from "../../utils/Utils";
import RequestAccess from "../../components/requestAccess/RequestAccess";
import MockInterviewGuide from "../../components/orgAdmin/mockInterview/MockInterviewGuide";

function OrgAdminMockInterview() {
  const userDetail = Utils.getUserDetail();

  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState();

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getModuleInfo();
  }, []);
  return (
    <>
      {loading && <Loader />}

      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="mockInterviews" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="mockInterviews"
            userRole={ROLES.org_admin}
            newTitle={`Mock Interview`}
          />
          {moduleInfo?.hasMockInterviewAccess ? (
            <MockInterviewGuide moduleInfo={moduleInfo} />
          ) : (
            <RequestAccess moduleName="MOCK_INTERVIEW" />
          )}
        </div>
      </div>
    </>
  );
}

export default OrgAdminMockInterview;
